// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__QQ7yP","log":"ModalInventoryLogs_log__1PCaD","date":"ModalInventoryLogs_date__lpwxf","userName":"ModalInventoryLogs_userName__1-LEL"};